import Menu from './components/Menu/Menu';

export default Menu;


// WEBPACK FOOTER //
// ./src/lib/index.js